/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyTaskCompletionUpdateDto } from './DailyTaskCompletionUpdateDto';
import {
    DailyTaskCompletionUpdateDtoFromJSON,
    DailyTaskCompletionUpdateDtoFromJSONTyped,
    DailyTaskCompletionUpdateDtoToJSON,
    DailyTaskCompletionUpdateDtoToJSONTyped,
} from './DailyTaskCompletionUpdateDto';

/**
 * 
 * @export
 * @interface UpdateDailyTaskGroupDto
 */
export interface UpdateDailyTaskGroupDto {
    /**
     * Checklist item states submitted by the group's Update button
     * @type {Array<DailyTaskCompletionUpdateDto>}
     * @memberof UpdateDailyTaskGroupDto
     */
    items?: Array<DailyTaskCompletionUpdateDto>;
    /**
     * Current aggregate amount for a hydration task; values may exceed the target
     * @type {number}
     * @memberof UpdateDailyTaskGroupDto
     */
    progressCurrent?: number;
}

/**
 * Check if a given object implements the UpdateDailyTaskGroupDto interface.
 */
export function instanceOfUpdateDailyTaskGroupDto(value: object): value is UpdateDailyTaskGroupDto {
    return true;
}

export function UpdateDailyTaskGroupDtoFromJSON(json: any): UpdateDailyTaskGroupDto {
    return UpdateDailyTaskGroupDtoFromJSONTyped(json, false);
}

export function UpdateDailyTaskGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDailyTaskGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(DailyTaskCompletionUpdateDtoFromJSON)),
        'progressCurrent': json['progressCurrent'] == null ? undefined : json['progressCurrent'],
    };
}

export function UpdateDailyTaskGroupDtoToJSON(json: any): UpdateDailyTaskGroupDto {
    return UpdateDailyTaskGroupDtoToJSONTyped(json, false);
}

export function UpdateDailyTaskGroupDtoToJSONTyped(value?: UpdateDailyTaskGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(DailyTaskCompletionUpdateDtoToJSON)),
        'progressCurrent': value['progressCurrent'],
    };
}

